export class StorageAcceptance
{
    id:number;
    storageAcceptancePerComfortTypeList:StorageAcceptancePerComfortType[];
}

export class StorageAcceptancePerComfortType
{
    comfortTypeId:number;
    storageAcceptanceValueList:StorageAcceptanceSingleValue[];
}
export class StorageAcceptanceSingleValue
{
    luggageTypeId:number;
    storageSpaceId:number;
    value:number;
}